import {setURLParams} from 'BenchlingUtil';
import EntityStore from 'stores/EntityStore';

interface ProcedurePageUrlOptions {
  procedureFlowchartVersionId?: string;
}

export function procedurePageUrl(procedureId: string, options: ProcedurePageUrlOptions = {}): string {
  let url = `/${EntityStore.currentUser().url_identifier}/procedures/${procedureId}`;
  if (options.procedureFlowchartVersionId) {
    url += `/v/${options.procedureFlowchartVersionId}`;
  }
  return setURLParams(url, {});
}
